module.exports = __webpack_public_path__ + "static/raghu-nayyar-EpAq2EE-shg-unsplash-6d0075a93911d2beb3f3fb47924eb0e4.png";